import { BASE_PATH } from '@/app/components/search/utils/path.ts';

export const API_CALL_PREFIX = `${BASE_PATH}/api/`;
